import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { getParametrage, createParametrage, updateParametrage, deleteParametrage } from '../services/api';
import { FiPlus, FiEdit2, FiTrash2, FiX } from 'react-icons/fi';

const titleMap: Record<string, string> = {
  directions: 'Directions',
  typecharges: 'Types de charge',
  typepaiements: 'Types de versement',
  typedocuments: 'Types de document',
  etapes: 'Étapes',
  rubriques: 'Rubriques',
};

const Parametrage = () => {
  const { table } = useParams<{ table: string }>();
  const [items, setItems] = useState<any[]>([]);
  const [showModal, setShowModal] = useState(false);
  const [editingId, setEditingId] = useState('');
  const [success, setSuccess] = useState('');
  const [error, setError] = useState('');
  const [form, setForm] = useState({ libelle: '', description: '' });

  const title = titleMap[table || ''] || table || 'Paramétrage';

  const loadData = () => {
    if (!table) return;
    getParametrage(table).then(r => {
      setItems(r.data);
    }).catch(() => {});
  };

  useEffect(() => { loadData(); }, [table]);

  const resetForm = () => setForm({ libelle: '', description: '' });

  const openAdd = () => { resetForm(); setEditingId(''); setShowModal(true); };
  const openEdit = (item: any) => {
    setForm({ libelle: item.libelle || '', description: item.description || '' });
    setEditingId(item.id);
    setShowModal(true);
  };

  const formatDate = (d: string) => {
    if (!d) return '-';
    const dt = new Date(d);
    const pad = (n: number) => n.toString().padStart(2, '0');
    return `${pad(dt.getDate())}/${pad(dt.getMonth() + 1)}/${dt.getFullYear()}`;
  };

  const handleSave = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!table) return;
    try {
      if (editingId) {
        await updateParametrage(table, editingId, form);
        setSuccess('Élément mis à jour');
      } else {
        await createParametrage(table, form);
        setSuccess('Élément créé avec succès');
      }
      setShowModal(false);
      loadData();
      setTimeout(() => setSuccess(''), 3000);
    } catch (err: any) {
      setError(err.response?.data?.error || 'Erreur');
      setTimeout(() => setError(''), 3000);
    }
  };

  const handleDelete = async (id: string) => {
    if (!table) return;
    if (!window.confirm('Supprimer cet élément ?')) return;
    await deleteParametrage(table, id);
    loadData();
  };

  return (
    <div>
      <h1 className="page-title">{title}</h1>

      {success && <div className="alert alert-success">{success}</div>}
      {error && <div className="alert alert-error">{error}</div>}

      <div className="card">
        <div className="card-header">
          <span>{title} ({items.length})</span>
          <button className="btn btn-success" onClick={openAdd}><FiPlus /> Ajouter</button>
        </div>
        <div className="card-body">
          <div className="table-responsive">
            <table className="data-table">
              <thead>
                <tr><th>Libellé</th><th>Description</th><th>Date</th><th>Actions</th></tr>
              </thead>
              <tbody>
                {items.map(item => (
                  <tr key={item.id}>
                    <td>{item.libelle || '-'}</td>
                    <td>{item.description || '-'}</td>
                    <td>{formatDate(item.created_at || item.date)}</td>
                    <td>
                      <div className="actions">
                        <button className="btn-icon btn-warning" onClick={() => openEdit(item)}><FiEdit2 /></button>
                        <button className="btn-icon btn-danger" onClick={() => handleDelete(item.id)}><FiTrash2 /></button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {/* Modal */}
      {showModal && (
        <div className="modal-overlay" onClick={() => setShowModal(false)}>
          <div className="modal" onClick={e => e.stopPropagation()}>
            <div className="modal-header">
              <h3>{editingId ? 'Modifier' : 'Ajouter'}</h3>
              <button className="modal-close" onClick={() => setShowModal(false)}><FiX /></button>
            </div>
            <form onSubmit={handleSave}>
              <div className="modal-body">
                <div className="form-group"><label>Libellé</label><input className="form-input" value={form.libelle} onChange={e => setForm({ ...form, libelle: e.target.value })} required /></div>
                <div className="form-group"><label>Description</label><textarea className="form-input" value={form.description} onChange={e => setForm({ ...form, description: e.target.value })} /></div>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-outline" onClick={() => setShowModal(false)}>Annuler</button>
                <button type="submit" className="btn btn-primary">Enregistrer</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default Parametrage;
